/** UserList コンポーネントが扱うユーザー 1 件。 */
export interface UserListUser {
	id: string;
	name: string;
	email: string;
}

/** 検索ドロップダウンに出す候補の最大件数。 */
export const MAX_USER_CANDIDATES = 8;

/**
 * 検索語にマッチする追加候補を返す。選択済みユーザーは除外し、
 * 名前またはメールアドレスの部分一致 (大文字小文字を無視) で絞り込む。
 * 検索語が空白のみなら候補を出さない。
 */
export function filterUserCandidates(
	users: UserListUser[],
	selectedIds: readonly string[],
	query: string,
): UserListUser[] {
	const needle = query.trim().toLowerCase();
	if (needle === "") return [];
	const selected = new Set(selectedIds);
	return users
		.filter(
			(u) =>
				!selected.has(u.id) &&
				(u.name.toLowerCase().includes(needle) || u.email.toLowerCase().includes(needle)),
		)
		.slice(0, MAX_USER_CANDIDATES);
}

/**
 * チップ削除後にフォーカスすべきチップの ID を返す。削除したチップの次 (右) を優先し、
 * 末尾を消した場合はひとつ前へ。リストが空になったら null (呼び出し側は検索欄へ戻す)。
 */
export function chipToFocusAfterRemove(
	selectedIds: readonly string[],
	removedId: string,
): string | null {
	const index = selectedIds.indexOf(removedId);
	if (index === -1) return null;
	const remaining = selectedIds.filter((id) => id !== removedId);
	if (remaining.length === 0) return null;
	return remaining[Math.min(index, remaining.length - 1)];
}
